module.exports = __webpack_public_path__ + "img/四川天府新区耘芽幼儿园.25ff56e6.jpg";